import { useTranslate } from '@/hooks'
import { Radio, RadioGroup } from '@heroui/react'
import { RefundTiming as RefundTimingEnum } from '@itsrever/returns-api-types/'

interface RefundTimingProps {
  timing: RefundTimingEnum
}

export const RefundTiming = ({ timing }: RefundTimingProps) => {
  const { translate } = useTranslate()

  return (
    <div className="space-y-3">
      <h2
        className="text-base font-medium"
        dangerouslySetInnerHTML={{
          __html: translate('confirmation_page_refund_timing_title')
        }}
      />
      <RadioGroup
        aria-label="Select the refund timing"
        defaultValue="standard"
        classNames={{
          wrapper:
            'gap-0 rounded-md border border-solid border-neutral-200 divide-y divide-neutral-200 overflow-hidden'
        }}
      >
        <Radio
          description={translate(`confirmation_page_refund_timing_${timing}`)}
          value="standard"
          size="sm"
          classNames={{
            base: 'items-start gap-1.5 group max-w-full m-0 px-4 py-4 data-[selected=true]:bg-neutral-50',
            wrapper: 'group-data-[selected=true]:border-brand-800',
            labelWrapper: 'gap-0.5 -mt-[0.1875rem]',
            label: 'text-sm font-medium',
            description: 'text-sm font-normal text-neutral-500',
            control: 'size-2 group-data-[selected=true]:bg-neutral-800'
          }}
        >
          {translate('confirmation_page_refund_timing_standard')}
        </Radio>
      </RadioGroup>
    </div>
  )
}
